import React from "react";
import AdminPageShell from "./AdminPageShell";
import useFetch from "../../useFetch";

const checkLabel = (value) => value ? "Passed" : "Failed";

const AdminSettings = () => {
  const { response, isLoading, error } = useFetch(process.env.REACT_APP_BASE_API_URL + "/admin/storage-diagnostics");
  const storage = response?.storage;

  const platformSettings = [
    { id: "disk", label: "Default Disk", value: storage?.disk ?? "Not loaded" },
    { id: "root", label: "Public Storage Root", value: storage?.public_root ?? "Not loaded" },
    { id: "url", label: "Public Storage URL", value: storage?.public_url ?? "Not loaded" },
    { id: "upload", label: "Upload Max Filesize", value: storage?.upload_limits?.upload_max_filesize ?? "Not loaded" },
    { id: "post", label: "Post Max Size", value: storage?.upload_limits?.post_max_size ?? "Not loaded" },
    { id: "max", label: "Max File Uploads", value: storage?.upload_limits?.max_file_uploads ?? "Not loaded" },
  ];

  return (
    <AdminPageShell
      active="settings"
      title="Platform Settings"
      text="Review production storage configuration and upload readiness."
    >
      <div className="ls-widget">
        <div className="widget-title"><h4>Upload Storage Diagnostics</h4></div>
        <div className="widget-content">
          {error && <div className="alert alert-danger"><strong>{error}</strong></div>}
          {isLoading && <h5 className="text-center my-3">Loading Data</h5>}

          {storage && (
            <>
              <div className="admin-detail-grid">
                <div className="admin-detail-item">
                  <span>Write Test</span>
                  <strong>{checkLabel(storage.write_test)}</strong>
                </div>
                <div className="admin-detail-item">
                  <span>Delete Test</span>
                  <strong>{checkLabel(storage.delete_test)}</strong>
                </div>
                {platformSettings.map((setting) => (
                  <div className="admin-detail-item" key={setting.id}>
                    <span>{setting.label}</span>
                    <strong>{setting.value}</strong>
                  </div>
                ))}
              </div>

              {storage.error && <div className="alert alert-danger mt-3"><strong>{storage.error}</strong></div>}
            </>
          )}
        </div>
      </div>

      <div className="ls-widget">
        <div className="widget-title"><h4>Upload Directories</h4></div>
        <div className="widget-content">
          <div className="admin-table-list">
            {(storage?.directories ?? []).map((item) => (
              <div className="admin-table-row" key={item.path}>
                <div>
                  <strong>{item.path}</strong>
                  <span>{item.sample_url}</span>
                </div>
                <span className={item.exists ? "" : "warning"}>{item.exists ? "Exists" : "Created on first upload"}</span>
              </div>
            ))}
            {!isLoading && !storage && !error && <div className="admin-empty-state">No diagnostics found.</div>}
          </div>
        </div>
      </div>
    </AdminPageShell>
  );
};

export default AdminSettings;
